import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/heading/heading.js';
      import {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
import {CompassDirection, HeadingPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/heading/heading.js';
import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';

      export interface Props {
     heading?: number;
     courseOverGround?: number;
     headingSetpoint?: number | null;
     newHeadingSetpoint?: number | undefined;
     atHeadingSetpoint?: boolean;
     headingSetpointAtZeroDeadband?: number;
     headingSetpointOverride?: boolean;
     autoAtHeadingSetpoint?: boolean;
     autoAtHeadingSetpointDeadband?: number;
     animateSetpoint?: boolean;
     touching?: boolean;
     headingAdvices?: AngleAdvice[];
     direction?: CompassDirection;
     priority?: Priority;
     priorityElements?: HeadingPriorityElement[];
     showLabels?: boolean;
     tickmarksInside?: boolean
   }

      
  
      export type {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
export type {CompassDirection, HeadingPriorityElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/heading/heading.js';
export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcHeading',
  props: {
    heading: {},
    courseOverGround: {},
    headingSetpoint: {},
    newHeadingSetpoint: {},
    atHeadingSetpoint: { type: Boolean },
    headingSetpointAtZeroDeadband: {},
    headingSetpointOverride: { type: Boolean },
    autoAtHeadingSetpoint: { type: Boolean },
    autoAtHeadingSetpointDeadband: {},
    animateSetpoint: { type: Boolean },
    touching: { type: Boolean },
    headingAdvices: {},
    direction: {},
    priority: {},
    priorityElements: {},
    showLabels: { type: Boolean },
    tickmarksInside: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-heading',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})